import createCrudService from '@core/api/create-crud-service';

import type { TCustomFieldFilter } from '@shared/types/custom-field-filter';
import type { TDynamicFilter } from '@shared/types/dynamic-filter';
import type { TField } from '@shared/types/field';

export type TCustomFieldFilterQuery = {
  page_number?: number;
  page_size?: number;
  custom_field?: number;
  type?: TField['type'];
  operator?: TDynamicFilter['operator'];
};

type CreateCustomFieldFilterPayload = {
  name?: string;
  type: TField['type'];
  operator: TDynamicFilter['operator'];
  value: string[];
  custom_field: number;
};

const customFieldFilterApi = createCrudService<
  TCustomFieldFilter,
  TCustomFieldFilterQuery,
  CreateCustomFieldFilterPayload
>({
  queryKey: ['custom-field-filters'],
  url: 'custom-field-filters',
});

export default customFieldFilterApi;
